module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticStyle: {
      "height": "680px",
      "overflow": "auto"
    }
  }, [_c('Row', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_vm._v("\n                     \n                ")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('app-left')], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('ul', {
    staticStyle: {
      "list-style": "none"
    }
  }, [_vm._l((_vm.projectList), function(project, index) {
    return _c('li', {
      staticClass: "project"
    }, [_vm._l((_vm.userDetailList), function(userDetail, index) {
      return (project.creatorId == userDetail.userId) ? _c('p', [_c('Row', [_c('Col', {
        attrs: {
          "span": "4"
        }
      }, [_c('span', {
        on: {
          "click": function($event) {
            return _vm.userInformation(userDetail.userId)
          }
        }
      }, [_c('a', [_vm._v(_vm._s(userDetail.nickName))])])]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "6"
        }
      }, [_c('span', {
        on: {
          "click": function($event) {
            return _vm.projectDetail(project.projectId, userDetail.userId)
          }
        }
      }, [_c('a', [_vm._v(_vm._s(project.projectName))])])]), _vm._v(" "), _c('Col', {
        attrs: {
          "span": "2"
        }
      }, [_vm._v("\n                                        " + _vm._s(_vm.dateFormat(project.creationTime)) + "\n                                    ")])], 1)], 1) : _vm._e()
    }), _vm._v(" "), _c('Row', [_c('Col', {
      attrs: {
        "span": "4"
      }
    }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "10"
      }
    }, [_vm._v(_vm._s(project.projectDesc))])], 1)], 2)
  }), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.isLoading) ? _c('Button', {
    attrs: {
      "type": "text",
      "loading": ""
    }
  }, [_vm._v("loading...")]) : _vm._e(), _vm._v(" "), (_vm.isNoMoreData) ? _c('Button', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v("no more data")]) : _vm._e()], 1)], 2)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('div', {
    staticClass: "postmiddle-right",
    staticStyle: {
      "background-color": "white",
      "margin": "0px auto",
      "text-align": "center"
    }
  }, [_c('ul', {
    staticStyle: {
      "list-style": "none",
      "font-size": "16px"
    }
  }, [_c('li', [_c('a', {
    on: {
      "click": _vm.createProject
    }
  }, [_vm._v("创建项目")])])])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35cb2af1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/project/ProjectIndex.vue
// module id = 428
// module chunks = 0